module.exports = __webpack_public_path__ + "img/chair.1f02732b.svg";